import * as yup from 'yup';
import { ApiGeoUnitWithDayConstraints } from '@ibe/api';

export class CamperSearchParams {
  public endDate?: string;

  public startDate?: string;

  public pickupStation: string;

  public dropOffStation: string;

  public adults?: string;

  public children?: string;

  public pickupStationGeoUnit?: ApiGeoUnitWithDayConstraints;

  public pickupStationParentGeoUnit?: ApiGeoUnitWithDayConstraints;

  public dropOffStationGeoUnit?: ApiGeoUnitWithDayConstraints;

  public dropOffStationParentGeoUnit?: ApiGeoUnitWithDayConstraints;
}

export const camperSearchSchema = yup
  .object()
  .shape({
    startDate: yup.string().required(),
    endDate: yup.string().required(),
    pickupStation: yup.string().required(),
    dropOffStation: yup.string().required(),
    adults: yup.number().required(),
    children: yup.number().required()
  })
  .defined();

export type ValidationError = yup.ValidationError;
export type CamperSearchSchema = yup.InferType<typeof camperSearchSchema>;
export type CamperSearchSchemaErrors = Partial<Record<keyof CamperSearchSchema, string[]>>;

export const validateCamperSearch = async (
  values: Partial<CamperSearchParams>
): Promise<CamperSearchSchemaErrors> => {
  const errors: { [key: string]: string[] } = {};

  await camperSearchSchema.validate(values, { abortEarly: false }).catch((e: ValidationError) => {
    e.inner.forEach(ee => {
      if (ee?.path) {
        errors[ee.path] = ee.errors;
      }
    });
  });

  return errors as CamperSearchSchemaErrors;
};
